import { Avatar, Menu, MenuItem } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useAuth } from '@/lib/hooks';
import { useGravatar } from '@/lib/hooks/useGravatar';

export const AvatarMenu = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = !!anchorEl;
    const { logout, user } = useAuth();
    const { imgSrc } = useGravatar(user?.gravatar_hash ?? undefined);

    const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const close = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleLogout = useCallback(() => {
        close();
        logout();
    }, [close, logout]);

    const handleChangePassword = useCallback(() => {
        close();
        navigate('/change-password');
    }, [close, navigate]);

    const handleProfile = useCallback(() => {
        close();
        navigate('/profile');
    }, [close, navigate]);

    if (!user) {
        return null;
    }
    return (
        <>
            <Avatar
                alt={user.name}
                src={imgSrc}
                onClick={handleClick}
                sx={{
                    bgcolor: deepOrange[500],
                    border: '3px solid white',
                    width: 30,
                    height: 30,
                    cursor: 'pointer',
                }}
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                {user.name[0]}
            </Avatar>
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={close}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <MenuItem onClick={handleProfile}>{t('label.profile', 'Profile')}</MenuItem>
                <MenuItem onClick={handleChangePassword}>{t('label.change_password', 'Change password')}</MenuItem>
                <MenuItem onClick={handleLogout}>{t('label.logout', 'Logout')}</MenuItem>
            </Menu>
        </>
    );
};
